/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MonitoringControllerExportMonitorings$Params {
  query?: string;
  statusId?: number;
  fiscalCode?: string;
  companyName?: string;
  startTimeFrom?: string;
  startTimeTo?: string;
  endTimeFrom?: string;
  endTimeTo?: string;
  field?: 'fiscalCode' | 'companyName' | 'startTime' | 'endTime' | 'id' | 'monitoringStatusId';
  direction?: 'asc' | 'desc';
  limit?: number;
  skip?: number;
}

export function monitoringControllerExportMonitorings(http: HttpClient, rootUrl: string, params?: MonitoringControllerExportMonitorings$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, monitoringControllerExportMonitorings.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('statusId', params.statusId, {});
    rb.query('fiscalCode', params.fiscalCode, {});
    rb.query('companyName', params.companyName, {});
    rb.query('startTimeFrom', params.startTimeFrom, {});
    rb.query('startTimeTo', params.startTimeTo, {});
    rb.query('endTimeFrom', params.endTimeFrom, {});
    rb.query('endTimeTo', params.endTimeTo, {});
    rb.query('field', params.field, {});
    rb.query('direction', params.direction, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

monitoringControllerExportMonitorings.PATH = '/monitoring/export';
